module.exports = __webpack_public_path__ + "img/document-download.e9691d41.svg";